// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content.svelte-3jw4be{max-width:800px;margin:0 auto;padding:0 6px}main.svelte-3jw4be{min-height:50vh}:root{--appelsinsorbet:#ffb27b;--pistasj:#6ba292;--friskis:#fee5ce;--kraesjpink:#bfb8da;--blaafruktfest:#8392de;--vannmelon:#f888a3;--mint:#6c966b;--lakris:#8a73ca;--tuttifrutti:#ff9567;--bringebaersorbet:#ffacac;--lavendel:#70e3ba}", ""]);
// Exports
module.exports = exports;
